/**
 * /admin/compliance-reports — the firm's FICA accountable-institution reporting
 * register (route shell). Screen impl in `./compliance-reports-screen.tsx`,
 * lazy-loaded. Mirrors the `admin/dsar` route shell.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/compliance-reports')({
  component: lazyRouteComponent(
    () => import('./compliance-reports-screen'),
    'AdminComplianceReports',
  ),
});
